<template>
  <div>
    <div>
      <el-button size="small" icon="el-icon-plus"  @click="editGroup(null)">添加分组</el-button>
    </div>

    <div v-for="group in groups" style="margin-bottom: 10px;">
      <span style="font-size: 18px;font-weight: 600;">{{ group.GroupName }}</span>
      <i class="el-icon-edit" style="font-size: 12px;margin: 0 10px;" @click="editGroup(group)"></i>
      <i class="el-icon-delete" style="font-size: 12px;color: red;" @click="delGroup(group)"></i>
      <div style="margin-top: 5px;">
        <el-tag size="small" style="margin-right: 10px;" v-for="item in group.SubItems">{{ item.GroupName }}</el-tag>

      </div>
    </div>

    <el-dialog title="编辑分组" :visible.sync="dialogVisible" width="600px">
      <div style="width: 80%;margin: 0 auto;">
        <el-form :model="editForm" ref="editForm" :rules="editFormRule" label-width="80px">
          <el-form-item label="父分组" prop="GroupName">
            <el-input v-model="editForm.GroupName" size="small" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item v-for="(item, index) in editForm.SubItems" :label="'子分组' + (index+1)" :key="item.key"
            :prop="'SubItems.' + index + '.GroupName'" :rules="{
              required: true, message: '分组名称不能为空', trigger: 'blur'
            }">
            <el-input v-model="item.GroupName" style="width: 250px;" size="small"></el-input>
            <el-button type="danger" icon="el-icon-delete"
              @click.prevent="removeGroup(index)" size="small"></el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="addGroupItem" size="small">新增子分组</el-button>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="submitEditGroup">确 定</el-button>
        <el-button type="info" size="small" @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import SystemService from "@/request-server/request-services/system-services.js";
import utilsCommon from '../../../utils/utils-common';
export default {
  data() {
    return {
      dialogVisible: false,
      groups: [],
      editForm: {
        GroupId: '',
        GroupName: '',
        SubItems: [{
          GroupId: '',
          GroupName: '',
        }]
      },
      editFormRule: {
        GroupName: [
          { required: true, message: '请输入分组名称', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.selectGroups();
  },
  methods: {
    selectGroups() {
      SystemService.getCommonMatchGroups().then(res => {
        if (res.code == 0) {
          this.groups = res.data;
        }
      })
    },
    delGroup(group) {
      this.$confirm(
        "是否确认要删除该组分组？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          SystemService.delCommonMatchGroups({ groupId: group.GroupId }).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.data);
              this.selectGroups();
            }
          });
        })
        .catch(() => { });
    },
    editGroup(group) {
      if (group) {
        this.editForm = utilsCommon.copyObj(group);
      } else {
        this.editForm = {
          GroupId: '',
          GroupName: '',
          SubItems: [{
            GroupId: '',
            GroupName: '',
          }]
        }
      }
      this.dialogVisible = true;
    },
    addGroupItem() {
      this.editForm.SubItems.push({
        GroupId: '',
        GroupName: ''
      })
    },
    removeGroup(index) {
      this.editForm.SubItems.splice(index, 1)
    },
    submitEditGroup() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          SystemService.editCommonMatchGroups(this.editForm).then(res => {
            if (res.code == 0) {
              this.$message.success(res.data);
              this.selectGroups();
              this.dialogVisible = false;
            }
          })
        }
      });
    }

  },
};
</script>

<style lang="scss" scoped></style>
